import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional
    dich_vu: {
        "id": undefined, // optional Mã tự sinh
        "loai": undefined,
        "duyet": // optional
        {
            "duoc_duyet": undefined, // optional Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
            "thoi_diem_duyet": undefined, // optional Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
            "nguoi_duyet_id": undefined, // optional Mã người duyệt
        },
        "diem_den_an_toan_id": undefined, // required điểm đến id
        "link_dich_vu": [ // optional
            {
                "id": undefined, // optional id của dịch vụ
                "link": undefined, // optional Tên dịch vụ
            }
        ],
        "luu_tru": // optional Lưu trú
        {
            "ten": undefined, // required Tên lưu trú
            "anh_hien_thi": null, // required Ảnh hiển thị
            "so_giuong_nguoi_lon": undefined, // optional Số giường người lớn
            "so_giuong_tre_em": undefined, // optional Số giường trẻ em
            "so_ngay_dat_phong": undefined, // optional Số ngày đặt phòng
            "mo_ta": undefined, // optional Mô tả lưu trú,
            "chi_tiet": undefined, // optional Mô tả lưu trú
        },
        "am_thuc": // optional Ẩm thực
        {
            "ten": undefined, // required Tên ẩm thực
            "anh_hien_thi": undefined, // required Ảnh hiển thị
            "mo_ta": undefined, // optional Mô tả ẩm thực
            "chi_tiet": undefined, // optional Chi tiết ẩm thực
        },
        "ly_do_tu_choi": undefined, // optional Lý do từ chối
        "ve_dien_tu": // optional Vé điện tử
        {
            "ten": undefined, // required Tên vé điệnt tử
            "url": undefined, // required Đường dẫn vé điện tử
            "anh_hien_thi": undefined, // required Ảnh hiển thị
        },
        "diem_den": // optional Điểm đến
        {
            "ten": undefined, // optional Tên điểm đến
            "anh_hien_thi": undefined, // required Ảnh hiển thị
            "mo_ta": undefined, // optional Giới thiệu điểm đến
            "chi_tiet": undefined, // optional Chi tiết điểm đến
        },
        "giai_tri": // optional Giải trí
        {
            "ten": undefined, // required Tên địa điểm giải trí
            "anh_hien_thi": undefined, // required Ảnh hiển thị
            "mo_ta": undefined, // optional Giới thiệu về khu giải trí
            "chi_tiet": undefined, // optional Chi tiết về khi giải trí
        }
    },
    diem_den_an_toan: {
        "du_lieu_khai_bao": // optional Dữ liệu khai báo khi đăng ký điểm đến
        {
            "user_account": undefined, // optional account của điểm đến
        },
    },
    duyet: // optional
    {
        duoc_duyet: null, // required Cho biết dịch vụ đã được duyệt hay chưa. 0: đã duyệt, 1: chờ xử lý, 2: Từ chối
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    diem_den: null, // optional Điểm đến
    mo_ta: null, // optional Mô tả dịch vụ lưu trú
    chi_tiet: null, // optional Chi tiết dịch vụ lưu trú
    thong_tin_chung: // optional Thông tin chung dịch vụ lưu trú
    {
        ten: null, // optional
        so_sao: 0, // optional Số sao của dịch vụ lưu trú
        anh: null, // optional Mã ảnh đại diện
        dia_chi: null, // optional Địa chỉ
        email: null, // optional Email
        website: null, // optional Website điểm lưu trú
        dien_thoai: null, // optional Điện thoại
        doi_tuong: null, // optional Đối tượng khách hàng hướng tới
        dich_vu: // optional Dịch vụ
        {
            giuong_nguoi_lon: 0, // optional Số giường người lớn
            giuong_tre_em: 0, // optional Số giường tre em
            ngay_nhan_phong: null, // optional Ngày nhận phòng
            ngay_tra_phong: null, // optional Ngày trả phòng
            url_traveloka: null, // optional Đường dẫn bên Traveloka
            url_ivivu: null, // optional Đường dẫn bên Ivivu
            url_agoda: null, // optional Đường dẫn bên Agoda
            url_vntrip: null, // optional Đường dẫn bên Vntrip
            url_chudu24: null, // optional Đường dẫn bên chudu24
        },
    },
    nguoi_tao_id: null, // optional Mã người tạo
    mediaId: null, // optional id media
    thoi_diem_tao: null, // optional Thời điểm tạo
}

model.validForm = {
  'dich_vu': {
    "luu_tru": {
      "ten": [ValidService.required],
      "anh_hien_thi": [ValidService.required],
      "so_giuong_nguoi_lon": [ValidService.required],
      "so_giuong_tre_em": [ValidService.required],
      "so_ngay_dat_phong": [ValidService.required],
      "mo_ta": [ValidService.required],
      "chi_tiet": [ValidService.required],
    },
    "ngon_ngu": [ValidService.required],
    "gia_tri_uu_dai": [],
    "link_mang_xa_hoi": [
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      }
    ]
  }
}

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-thoi_gian_tao",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "luu_tru.ten": "",
            diem_den: "",
            'duyet.duoc_duyet': '',
            // ready: true,
            visible: "",
            ngon_ngu: ""
        },
        valid: {
            "luu_tru.ten": [],
            diem_den: [],
            'duyet.duoc_duyet': [],
        },
        operator: {
            "luu_tru.ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            diem_den: ":regex:",
            'duyet.duoc_duyet': '',
        }
    },
    vn_text: ""
};

export default model;
